import React from 'react'
import { Elements } from '@stripe/react-stripe-js'
import stripePromise from './loadStripePromise'

const defaultOptions = {
  fonts: [
    {
      cssSrc: 'https://fonts.googleapis.com/css?family=Roboto',
    },
  ],
}

const withStripeElements = (Component, options = defaultOptions) => props => {
  return (
    <Elements stripe={stripePromise} options={options}>
      <Component {...props} />
    </Elements>
  )
}

export default withStripeElements
